import analytics from 'analytics.js';
import events from 'events.js';
import trackPhones from 'track-phones.js';

(async function() {
    await events.ready();

    const trackData = JSON.parse(document.body.dataset.trackData);
    analytics.track('organisationDetail', trackData);
})();

function trackPhoneHS(phoneNumber) {
    analytics.track('organisationPhoneClick', {
        'organisation': document.body.getAttribute('data-profile-id'),
        'phone_number': phoneNumber,
    });
}

trackPhones(trackPhoneHS);
